import script from "./GestaoPermissoesGrupo.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoPermissoesGrupo.vue?vue&type=script&setup=true&lang=js"

import "./GestaoPermissoesGrupo.vue?vue&type=style&index=0&id=3f24552f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f24552f"]])

export default __exports__